import React, { FC } from 'react'
import { Provider } from 'react-redux'

import { store } from './store'

export const FeatureStateProvider: FC = ({ children }) => <Provider children={children} store={store} />
